const List = [
  {
    id: 1,
    title:"Vegetable Frozen Momo",
    image: "../images/momo8.png",
    price:
    "Rs.200 ",
  },
  {
    id: 2,
    title:"Chicken Frozen Momo",
    image: "../images/momo2.png",
    price:
    "Rs.200",
  },
  {
    id: 3,
    title:"Veg Frozen Momo",
    image: "../images/momo3.png",
    price:
    "Rs.200",
  },
  {
    id: 4,
    title:"Chicken Frozen Momo",
    image: "../images/momo4.png",
    price:
    "Rs.200",
  }
];

export default List;
